<template>
  <footer class="site-footer">
    <div class="content-max-width top flex flex-between">
      <div class="note desktop">
        <h3>Note it in your calendar!</h3>
        <div class="flex">
          <a href="/whats-on">
            <img src="/images/calendar.png" alt="" class="calendar">
          </a>
          <img src="/images/note-arrow.png" alt="" class="arrow">
        </div>
      </div>

      <div class="get-in-touch">
        <div class="social flex align-center">
          <a  target="_blank" v-for="(item, index) of data.social"
              :href="item.link"
              :key="index">
            <img :src="item.image" :alt="item.alt">
          </a>
          <a class="button subscribe desktop" @click="showingSubscribeModal = true">Subscribe</a>
          <a :href="data.diabetes.link" class="button diabetes desktop" target="_blank">Diabetes NZ <img src="/images/link-white.svg" alt="" class="link"></a>
        </div>

        <h2>Get in touch</h2>

        <div class="flex contacts">
          <div class="flex phone align-center">
            <img src="/images/phone.svg" alt="">
            <a :href="data.phone.link"><span>{{ data.phone.title }}</span></a>
          </div>
          <div class="flex email align-center">
            <img src="/images/mail.svg" alt="">
            <a :href="data.email.link"><span>{{ data.email.title }}</span></a>
          </div>
      </div>

        <!-- <div class="subscribe flex">
          <p>Sign up</p>
          <div class="input">
            <input type="email" placeholder="Email Address">
            <button><img src="/images/plane.png" alt="submit" class="submit"></button>
          </div>

        </div> -->
      </div>
    </div>
    <div class="footer-legal">
      <div class="content-max-width flex">
          <hr class="mobile" style="width:90%; margin-bottom: 20px;">
        <p class="copyright">© Diabetes NZ 2022</p>
        <a
          href="http://www.brownpaperbag.co.nz/"
          target="_blank"
          class="attribution"
        >website by brownpaperbag</a>
      </div>
    </div>
    <Modal v-if="showingSubscribeModal" @close="showingSubscribeModal = false">
      <div v-if="sent==false">
        <div class="form-fields-stack">
          <div class="form-field col col-6">
              <label for="first_name">First Name</label>
              <input type="text" placeholder="" name="first_name" required v-model="payload.first_name">
          </div>
          <div class="form-field col col-6">
              <label for="last_name">Last Name</label>
              <input type="text" placeholder="" name="last_name" required  v-model="payload.last_name">
          </div>
        </div>
        <div class="form-field">
          <label for="location">Location</label>
              <input type="text" placeholder="" name="location" required v-model="payload.location">
        </div>
        <div class="form-fields-stack">
          <div class="form-field col col-6">
              <label for="email">Email Address</label>
              <input type="text" placeholder="" name="email" required v-model="payload.email">
          </div>
          <div class="form-field col col-6">
            <label for="interests">Interests</label>
            <SelectDropdown :options="interests"  v-model="payload.interest">
            </SelectDropdown>
          </div>
        </div>

        <div class="form-field custom-checkbox-radio">
          <input type="checkbox" v-model="payload.has_updates">
          <label for="">Would you like to receive updates from Diabetes NZ</label>
        </div>

        <button class="button" :disabled="isDisabled" @click="subscribe">
          Subscribe
        </button>
      </div>
      <div v-else>
        <div class="form-field">
          <label for="location">You have successfully subscribed.</label>              
        </div>
      </div>
    </Modal>
  </footer>
</template>

<script>
import Modal from './Modal.vue'
import SelectDropdown from './SelectDropdown.vue'

export default {
  components: {
    Modal,
    SelectDropdown,
  },

  props: [
    'data'
  ],

  data () {
    return {
      sent: false,
      isDisabled: false,
      showingSubscribeModal: false,
      interests: [
        'Type 1 Diabetes',
        'Type 2 Diabetes',
        'Gestational',
        'Family Member',
        'Journalist',
        'None of these',
      ],
      payload : {
        first_name: '',
        last_name: '',
        location: '',
        email: '',
        interest: '',
        has_updates: ''
      }
    }
  },

  methods: {
    
    subscribe() {
      if (this.payload.email) {
        if (this.modValidateEmail(this.payload.email)) {
          
          this.isDisabled = true
          
          window.axios.post('/api/subscribers', this.payload)
            .then(response => {
              
              this.$store.commit('setPopup', {
                open: true,
                content: '<p>The email ' + this.payload.email + ' has been added to the subscriber list</p>'
              })
              console.log('The email ' + this.payload.email + ' has been added to the subscriber list');
              
              this.isDisabled = false
              this.payload.email = null
              this.payload.first_name = null
              this.payload.last_name = null
              this.payload.location = null
              this.payload.interest = null
              this.payload.has_updates = null
              this.sent = true
              
            })
            .catch(error => {
              this.$store.commit('setPopup', {
                open: true,
                content: '<p>' + error.response.data.message +'</p>'
              })
              console.log(error.response.data.message);
              this.isDisabled = false
            })
          
        } else {
          this.$store.commit('setPopup', {
            open: true,
            content: '<p>Invalid email address</p>'
          })
          console.log('Invalid email address');
        }
      } else {
        this.$store.commit('setPopup', {
          open: true,
          content: '<p>Please enter email address</p>'
        })
        console.log('Please enter email address');
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// resources/assets/frontend/js/components/Footer.vue